module.exports = __webpack_public_path__ + "static/78gde-5936b65f005bb8903eb06c9d5c52b5e7.gif";